
import { format, differenceInYears, parseISO, isValid } from 'date-fns';
import { el, enUS } from 'date-fns/locale';

export const getLocale = (language: string) => {
  return language === 'el' ? el : enUS;
};

export const calculateAge = (birthDate: string | Date | undefined): number | null => {
  if (!birthDate) return null;
  
  try {
    const date = typeof birthDate === 'string' ? parseISO(birthDate) : birthDate;
    if (!isValid(date)) return null;
    
    return differenceInYears(new Date(), date);
  } catch {
    return null;
  }
};

export const formatBirthDate = (birthDate: string | undefined, language: string): string => {
  if (!birthDate) return '';
  
  try {
    const date = parseISO(birthDate);
    if (!isValid(date)) return '';
    
    const locale = getLocale(language);
    return format(date, 'dd/MM/yyyy', { locale });
  } catch {
    return '';
  }
};

export const formatDateForInput = (date: string | undefined): string => {
  if (!date) return '';
  
  try {
    const parsedDate = parseISO(date);
    if (!isValid(parsedDate)) return '';
    
    return format(parsedDate, 'yyyy-MM-dd');
  } catch {
    return '';
  }
};

// Localized date formatting functions
export const formatDateWithDay = (date: Date | string, language: string): string => {
  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : date;
    if (!isValid(dateObj)) return '';
    
    const locale = getLocale(language);
    return format(dateObj, 'EEEE, dd/MM/yyyy', { locale });
  } catch {
    return '';
  }
};

export const formatShortDateWithDay = (date: Date | string, language: string): string => {
  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : date;
    if (!isValid(dateObj)) return '';
    
    const locale = getLocale(language);
    return format(dateObj, 'EEE, dd/MM/yyyy', { locale });
  } catch {
    return '';
  }
};

export const formatCalendarDate = (date: Date, language: string, isMobile: boolean = false): string => {
  try {
    const locale = getLocale(language);
    if (isMobile) {
      return format(date, 'EEE, MMM d', { locale });
    } else {
      return format(date, 'EEEE, MMMM d, yyyy', { locale });
    }
  } catch {
    return '';
  }
};

export const formatUpcomingBookingDate = (date: Date | string, language: string): string => {
  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : date;
    if (!isValid(dateObj)) return '';
    
    const locale = getLocale(language);
    return format(dateObj, 'EEEE, MMM d', { locale });
  } catch {
    return '';
  }
};

export const formatLocalizedDate = (date: Date | string, language: string): string => {
  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : date;
    if (!isValid(dateObj)) return '';
    
    const locale = getLocale(language);
    return format(dateObj, 'dd/MM/yyyy', { locale });
  } catch {
    return '';
  }
};

export const formatPaymentDate = (date: Date | string, language: string): string => {
  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : date;
    if (!isValid(dateObj)) return '';
    
    const locale = getLocale(language);
    return format(dateObj, 'EEEE, dd/MM/yyyy', { locale });
  } catch {
    return '';
  }
};
